<template>
    <div>
      <div id="PengajuanManagement">
        <div class="overflow-auto">
          <h2>Konfirmasi Pembayaran</h2>
          <div class="row no-gutters mb-4">
            <div class="col-md-9">
              <label>Filter Berdasarkan Tanggal :</label>
              <div class="form-inline">
                <input name="start_date" type="text" onfocus="(this.type='date')" placeholder="Mulai Dari"
                  class="form-control mr-2">
                <input name="end_date" type="text" onfocus="(this.type='date')" placeholder="Sampai Dengan"
                  class="form-control mr-2">
                <b-button class="btn btn-custom btn-sm" @click="applyDateFilter">Filter</b-button>
              </div>
            </div>
          </div>
  
          <div class="overflow-auto">
            <b-table id="pengajuan-table" responsive="true" :items="pengajuanItems" :fields="pengajuanFields"
              :current-page="currentPagePengajuan" :per-page="perPagePengajuan">
              <template v-slot:cell(id_transaksi)="data">
                <div>{{ data.item.id }}</div>
              </template>
              <template v-slot:cell(product)="data">
                <div>{{ data.item.product.nama_produk }}</div>
              </template>
              <template v-slot:cell(funder)="data">
                <div>{{ data.item.funder.name }}</div>
              </template>
              <template v-slot:cell(setoran_awal)="data">
                <div>Rp.{{ new Intl.NumberFormat().format(data.item.setoran_awal) }}</div>
              </template>
              <template v-slot:cell(status_pengajuan)="data">
                <div>{{ data.item.status_pengajuan.name }}</div>
              </template>
              <template v-slot:cell(status_pembayaran)="data">
                <div>{{ data.item.latest_payment_confirmation ? convertStatusPembayaran(data.item.latest_payment_confirmation.status) : 'Menunggu Pembayaran' }}</div>
              </template>
              <template v-slot:cell(aksi)="data">
                <b-button v-if="data.item.status_pengajuan_id == 6 && data.item.latest_payment_confirmation"
                  @click="showDetail(data.item)" type="button" variant="primary" class="btn btn-custom theme-color">
                  Detail
                </b-button>
                <b-button v-if="data.item.status_pengajuan_id == 6 && data.item.latest_payment_confirmation && data.item.latest_payment_confirmation.status == 'pending'"
                  @click="changeStatus(data.item, 'approve')" type="button" variant="success"
                  class="btn btn-custom theme-color success">
                  Setujui
                </b-button>
                <b-button v-if="data.item.status_pengajuan_id == 6 && data.item.latest_payment_confirmation && data.item.latest_payment_confirmation.status == 'pending'"
                  @click="changeStatus(data.item, 'reject')" type="button" variant="danger"
                  class="btn btn-custom theme-color cancel">
                  Tolak
                </b-button>
              </template>
            </b-table>
          </div>
  
          <!-- Modal Detail -->
            <newCustomModal :visible="showDetailModal" @close="showDetailModal = false" size="large" :showClose="false">
                <template v-slot:default>
                <div class="text-center">
                    <h3>{{ modalTitle }}</h3>
                    <div class="preview-wrapper">
                    <div
                        v-for="(img, index) in bukti_pembayaran"
                        :key="index"
                        class="preview-image"
                        @click="openImageModal(img)"
                    >
                        <img :src="img" alt="Bukti Pembayaran" />
                    </div>
                    </div>
                </div>
                </template>
            </newCustomModal>

            <!-- Modal Konfirmasi Status -->
            <newCustomModal :visible="confirmStatusModal" @close="confirmStatusModal = false" size="large" :showClose="false">
                <template v-slot:default>
                <div class="text-center">
                    <h3>{{ modalTitle }}</h3>
                    <div class="preview-wrapper">
                    <div
                        v-for="(img, index) in bukti_pembayaran"
                        :key="index"
                        class="preview-image"
                        @click="openImageModal(img)"
                    >
                        <img :src="img" alt="Bukti Pembayaran" />
                    </div>
                    </div>

                    <div v-if="!changingStatus" class="row mt-3">
                    <div class="col" v-if="status_pembayaran == 'pending'">
                        <b-button class="mt-3 btn-custom success" block @click="confirmChangeStatus">Ya</b-button>
                    </div>
                    <div class="col">
                        <b-button class="mt-3 btn-custom cancel" block @click="confirmStatusModal = false">Tutup</b-button>
                    </div>
                    </div>
                    <div v-else class="row">
                    <div class="col text-center">
                        <b-spinner variant="primary"></b-spinner>
                    </div>
                    </div>
                </div>
                </template>
            </newCustomModal>

            <!-- Modal Zoom Gambar -->
            <newCustomModal :visible="showImageModal" @close="showImageModal = false" size="large">
                <template v-slot:default>
                <div class="text-center">
                    <img :src="selectedImage" alt="Zoom Gambar" class="zoom-image" />
                </div>
                </template>
            </newCustomModal>
  
          <h2 v-if="loaded == false" class="text-center"><b-spinner variant="warning"></b-spinner></h2>
          <b-pagination align="center" :total-rows="rowsPengajuan" :per-page="perPagePengajuan"
            aria-controls="pengajuan-table" v-model="currentPagePengajuan"></b-pagination>
        </div>
      </div>
    </div>
  </template>
  <script>
  import Pengajuan from "../../api/pengajuan.js";
  import newCustomModal from "../../components/newCustomModal.vue"
  
  const pengajuanFields = [
    { key: 'id_transaksi', label: 'ID Transaksi', sortable: false },
    { key: 'product', label: 'Nama Produk', sortable: true },
    { key: 'funder', label: 'Nama Nasabah', sortable: true },
    { key: 'setoran_awal', label: 'Setoran Awal', sortable: true },
    { key: 'status_pengajuan', label: 'Status Pengajuan', sortable: true },
    { key: 'status_pembayaran', label: 'Status Pembayaran', sortable: true },
    { key: 'aksi', label: 'Aksi' }
  ];
  
  export default {
    name: "ManajemenPengajuan",
    components: { newCustomModal },
    data() {
      return {
        pengajuanItems: [],
        pengajuanFields,
        perPagePengajuan: 5,
        currentPagePengajuan: 1,
        showDetailModal: false,
        confirmStatusModal: false,
        showImageModal: false,
        successModal: false,
        modalTitle: '',
        changingStatus: false,
        loaded: false,
        bukti_pembayaran: [],
        status_pembayaran: '',
        action: '',
        errorModal: false,
        selectedImage: null,
      };
    },
    computed: {
      rowsPengajuan() {
        return this.pengajuanItems.length;
      }
    },
    mounted() {
      this.loadData();
    },
    methods: {
      loadData() {
        Pengajuan.pengajuanPaymentMitra()
          .then(res => {
            this.pengajuanItems = res.data.data.sort((a, b) => {
              const statusA = a.latest_payment_confirmation ? a.latest_payment_confirmation.status : '';
              const statusB = b.latest_payment_confirmation ? b.latest_payment_confirmation.status : '';
              if (statusA === 'pending') return -1;
              if (statusB === 'pending') return 1;
              return 0;
            });
            this.loaded = true;
          })
          .catch(err => console.log(err));
      },
      showDetail(item) {
        this.product_id = item.latest_payment_confirmation.id;
        this.status_pengajuan_id = item.status_pengajuan_id;
        this.status_pembayaran = item.latest_payment_confirmation.status;
        this.bukti_pembayaran = item.latest_payment_confirmation.images || [];
        this.modalTitle = `Bukti Pembayaran Nasabah`;
        this.showDetailModal = true;
      },
      changeStatus(item, action) {
        this.product_id = item.latest_payment_confirmation.id;
        this.status_pengajuan_id = item.status_pengajuan_id;
        this.status_pembayaran = item.latest_payment_confirmation.status;
        this.bukti_pembayaran = item.latest_payment_confirmation.images || [];
        this.modalTitle = `Apa anda yakin ingin ${action === 'approve' ? 'menyetujui' : 'menolak'} pembayaran ini?`;
        this.action = action;
        this.confirmStatusModal = true;
      },
      confirmChangeStatus() {
        this.changingStatus = true;
        const data = {
            id: this.product_id,
            status: this.action === 'approve' ? 'approved' : 'rejected'
        };
        Pengajuan.changePaymentStatus(data)
            .then(res => {
            if (res.data.meta.code === 200) {
                this.confirmStatusModal = false;
                if (this.action === 'approve') {
                this.$toast.success("Berhasil menyetujui pembayaran.");
                } else {
                this.$toast.success("Berhasil menolak pembayaran.");
                }
                this.loadData();
            } else {
                this.confirmStatusModal = false;
                if (this.action === 'approve') {
                this.$toast.error("Gagal menyetujui pembayaran." || res.data.meta.message);
                } else {
                this.$toast.error("Gagal menolak pembayaran." || res.data.meta.message);
                }
                this.loadData();
            }
            this.changingStatus = false;
            })
            .catch(err => {
            console.log(err);
            this.$toast.error("Terjadi kesalahan sistem.");
            this.changingStatus = false;
            });
        },
      convertStatusPembayaran(status) {
        switch (status) {
          case 'pending':
            return 'Menunggu Konfirmasi Mitra';
          case 'approved':
            return 'Disetujui Mitra';
          case 'rejected':
            return 'Ditolak Mitra';
          default:
            return '';
        }
      },
      openImageModal(img) {
        this.selectedImage = img;
        this.showImageModal = true;
      }
    },
  };
  </script>
  
  <style scoped>
  .preview-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    justify-content: center;
  }
  
  .preview-image {
    width: 220px;
    height: 220px;
    border-radius: 8px;
    overflow: hidden;
    flex-shrink: 0;
    cursor: pointer;
    border: 1px solid #ddd;
    box-shadow: 0 2px 6px rgba(0,0,0,0.15);
    transition: transform .2s;
  }
  .preview-image:hover {
    transform: scale(1.05);
  }
  
  .preview-image img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    background: #f9f9f9;
  }
  
  @media(max-width:768px) {
    .preview-image {
      width: 120px;
      height: 120px;
    }
  }
  
  .zoom-image {
    max-width: 90%;
    max-height: 80vh;
    object-fit: contain;
    border-radius: 10px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.25);
  }
  </style>


// WEBPACK FOOTER //
// src/components/dashboard/konfirmasi-pembayaran.vue